<div class="flex flex-col justify-start text-md w-[374px] gap-3">
    <div class="flex flex-col w-full shadow text-slate-50 bg-ponder-light rounded-md">
        <div class="flex flex-row gap-2 pl-2 pr-2 pt-2 pb-1 ">
            {{ searchTerm }}
        </div>
        <div class="pb-1">
            <table class="table-auto text-xs text-slate-200 truncate rounded-b-md">
                <tbody>
                    <tr class="bg-ponder-light">
                        <td class="pl-2 pr-2">Results</td>
                        <td class="pl-2 pr-2">{{ getCount() }} cards</td>
                        <td class="pl-2 pr-2">{{ getValue() }}</td>
                        <td class="pl-2 pr-2 w-full text-foil">{{ getSpecialValue() }}</td>
                    </tr>
                    @if (hasAuth()) {
                    <tr class="bg-ponder-xlight rounded-b-md">
                        <td class="pl-2 pr-2">Collected</td>
                        <td class="pl-2 pr-2">
                            <div class="flex flex-row gap-2 ">
                                <div>{{ getDistinctCollectedCount() }} cards</div>
                                @if (hasCollected()) { <div class="text-slate-200 text-opacity-70">({{ getCollectedCount() }} total)</div> }
                            </div>
                        </td>
                        <td class="pl-2 pr-2">@if (hasCollected()) { {{ getCollectedValue() }} }</td>
                        <td class="pl-2 pr-2"></td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>
</div>